module.exports = __webpack_public_path__ + "media/images/lb/382-4fffe331df97502045fb7f68db6300d4.svg";